import { getRootDomain, encodeDomainToCookieSuffix, useCookie } from './useCookie';
import { CookieStorageOptions } from '../services/utils/CookieStorage';
import { Ref } from 'vue';

const COOKIE_NAME_BASE = 'lendi-access-token';
const DEFAULT_EXPIRATION_SECONDS = 7 * 24 * 60 * 60;
/**
 * A composable function to manage the access token cookie
 * Uses domain-specific cookie name to avoid ambiguity across domains
 * @param {number} expiresInSeconds - Expiration time in seconds. If not provided, defaults to 7 days.
 * @returns {Ref<string | undefined>} The access token cookie reference (can be undefined)
 */
export const useAccessCookie = (expiresInSeconds?: number): Ref<string | undefined> => {
  const rootDomain = getRootDomain();
  const domainSuffix = encodeDomainToCookieSuffix(rootDomain);
  const cookieName = `${COOKIE_NAME_BASE}-${domainSuffix}`;

  const cookieOptions: Partial<CookieStorageOptions> = {
    domain: rootDomain,
    sameSite: 'lax',
    secure: window.location.protocol === 'https:',
    path: '/'
  };

  const expirationSeconds = expiresInSeconds ?? DEFAULT_EXPIRATION_SECONDS;

  return useCookie<string | undefined>(cookieName, expirationSeconds, cookieOptions);
};

export default useAccessCookie;
